export enum AudioGraphNodeType
{
  Gain,
  MediaElementAudioSource,
  BiquadFilter,
  DynamicsCompressor
}

export class AudioGraphNodeTypes
{

}
